import React from 'react';
import './style.css';
import comp from "../../Assets/Why/comp.png"
import exp from "../../Assets/Why/exp.png"
import flex from "../../Assets/Why/flex.png"
import secu from "../../Assets/Why/secu.png"
import str from "../../Assets/Why/str.png"
import top from "../../Assets/Why/top.png"

const features = [
  {
    title: 'Trusted and Reliable Company',
    description: '',
    icon: comp,
    position: 'top',
  },
  {
    title: 'Experienced',
    description: '',
    icon: exp,
    position: 'top-right',
  },
  {
    title: 'High Security without Increase of Cost',
    description: 'Using FC Management system',
    icon: flex,
    position: 'bottom-right',
  },
  {
    title: 'Adequate Security Services',
    description: 'Up to 7 years',
    icon: secu,
    position: 'bottom',
  },
  {
    title: 'Required Security Solutions',
    description: '',
    icon: str,
    position: 'bottom-left',
  },
  {
    title: 'Top Security',
    description: 'For all corporate clients',
    icon: top,
    position: 'top-left',
  },
];

const FreightCircle = () => {
  return (
    <div className="freight-circle-container">
    <div className="circle-center">
      <h2>WHY<br />CHOOSE<br />US</h2>
    </div>
  
    <div className="circle-orbit">
      {features.map((item, index) => (
        <div key={index} className={`circle-item ${item.position}`}>
          <div className="circle-content">
    <img className='icon' src={item.icon} alt={item.title} />
    <h4>{item.title}</h4>
  </div>
        </div>
      ))}
    </div>
  </div>
  
  );
};

export default FreightCircle;
